
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPropulsionTunnelThruster as ObiPropulsionTunnelThrusterElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-propulsion-tunnel-thruster.js';
 
 
 

 
 export const ObiPropulsionTunnelThruster = createComponent({
   react: React,
   tagName: 'obi-propulsion-tunnel-thruster',
   elementClass: ObiPropulsionTunnelThrusterElement,
   events: {
     
   }
  });
 
 